if (!customElements.get('wr-shop-menu')) {
  customElements.define('wr-shop-menu', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      const options = {signal: this.events.signal};
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      const panel = this.querySelector('.wr-shop-dropdown');
      const position = () => {
        const rect = this.summary.getBoundingClientRect();
        const width = Math.min(780, innerWidth - 48);
        panel.style.setProperty('--wr-menu-left', Math.max(24, Math.min(rect.left, innerWidth - width - 24)) + 'px');
        panel.style.setProperty('--wr-menu-top', rect.bottom + 12 + 'px');
      };
      const open = () => { clearTimeout(this.closeTimer); position(); this.details.open = true; };
      this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') open(); }, options);
      this.addEventListener('pointerleave', () => { this.closeTimer = setTimeout(() => { if (!this.contains(document.activeElement)) this.details.open = false; }, 180); }, options);
      this.addEventListener('focusin', event => { if (event.target !== this.summary) open(); }, options);
      this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) this.details.open = false; }, options);
      this.details.addEventListener('toggle', () => { this.summary.setAttribute('aria-expanded', String(this.details.open)); if (this.details.open) position(); }, options);
      this.addEventListener('keydown', event => { if (event.key === 'Escape') { this.summary.focus(); this.details.open = false; } }, options);
      document.addEventListener('click', event => { if (!this.contains(event.target)) this.details.open = false; }, options);
      window.addEventListener('resize', position, options);
      window.addEventListener('scroll', () => { if (this.details.open) position(); }, {...options, passive: true});
    }
    disconnectedCallback() { this.events?.abort(); this.events = null; clearTimeout(this.closeTimer); }
  });
}
if (!customElements.get('wr-model-orbit')) {
  customElements.define('wr-model-orbit', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      const options = {signal: this.events.signal};
      this.cards = [...this.querySelectorAll('[data-model-card]')];
      this.dots = [...this.querySelectorAll('[data-model-dot]')];
      this.active = 0;
      this.shop = this.querySelector('[data-shop-model]');
      this.status = this.querySelector('[data-model-status]');
      this.pause = this.querySelector('[data-model-pause]');
      this.mobile = matchMedia('(max-width: 749px)');
      this.autoplay = this.dataset.autoplay === 'true' && !matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.pointerInside = false;
      this.visible = false;
      const render = (announce = false) => {
        const length = this.cards.length;
        this.cards.forEach((card, index) => {
          let distance = (index - this.active + length) % length;
          if (distance > length / 2) distance -= length;
          const magnitude = Math.abs(distance);
          const active = magnitude === 0;
          card.hidden = magnitude > 2;
          card.dataset.active = String(active);
          card.setAttribute('aria-hidden', String(!active));
          card.style.setProperty('--wr-offset', distance);
          card.style.setProperty('--wr-scale', active ? 1 : magnitude === 1 ? .78 : .57);
          card.style.setProperty('--wr-angle', distance === 0 ? '0deg' : distance > 0 ? '-24deg' : '24deg');
          card.style.setProperty('--wr-depth', magnitude * -55 + 'px');
          card.style.setProperty('--wr-opacity', active ? 1 : magnitude === 1 ? .68 : .32);
          card.style.setProperty('--wr-z', 5 - magnitude);
          card.querySelector('a').tabIndex = active ? 0 : -1;
        });
        this.dots.forEach((dot, index) => dot.setAttribute('aria-pressed', String(index === this.active)));
        const card = this.cards[this.active];
        this.shop.href = card.querySelector('a').href;
        this.shop.setAttribute('aria-label', this.shop.dataset.label + ' — ' + card.dataset.title);
        if (announce) this.status.textContent = card.dataset.title;
        if (this.pause) {
          this.pause.hidden = this.mobile.matches;
          this.pause.textContent = this.autoplay ? this.pause.dataset.pause : this.pause.dataset.play;
          this.pause.setAttribute('aria-pressed', String(!this.autoplay));
        }
      };
      const choose = (index, announce = true) => {
        this.active = (index + this.cards.length) % this.cards.length;
        render(announce);
        restart();
      };
      const restart = () => {
        clearInterval(this.timer);
        if (this.cards.length > 1 && this.autoplay && !this.mobile.matches && this.visible && !this.pointerInside && !this.contains(document.activeElement) && !document.hidden) {
          this.timer = setInterval(() => choose(this.active + 1, false), 6500);
        }
      };
      this.addEventListener('click', event => {
        const step = event.target.closest('[data-model-step]');
        const dot = event.target.closest('[data-model-dot]');
        const card = event.target.closest('[data-model-card]');
        if (step) choose(this.active + Number(step.dataset.modelStep));
        if (dot) choose(Number(dot.dataset.modelDot));
        if (card && (card.dataset.active !== 'true' || Date.now() - (this.swipeAt || 0) < 400)) {
          event.preventDefault();
          if (card.dataset.active !== 'true') choose(this.cards.indexOf(card));
        }
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); choose(this.active + (event.key === 'ArrowRight' ? 1 : -1)); }
      }, options);
      const stage = this.querySelector('.wr-model-orbit__stage');
      stage.addEventListener('pointerdown', event => { this.pointerStart = {x: event.clientX, y: event.clientY}; }, options);
      stage.addEventListener('pointerup', event => {
        if (!this.pointerStart) return;
        const delta = event.clientX - this.pointerStart.x;
        if (Math.abs(delta) > 45 && Math.abs(delta) > Math.abs(event.clientY - this.pointerStart.y)) { this.swipeAt = Date.now(); choose(this.active + (delta < 0 ? 1 : -1)); }
        this.pointerStart = null;
      }, options);
      stage.addEventListener('pointercancel', () => { this.pointerStart = null; }, options);
      this.addEventListener('pointerenter', () => { this.pointerInside = true; restart(); }, options);
      this.addEventListener('pointerleave', () => { this.pointerInside = false; restart(); }, options);
      this.addEventListener('focusin', restart, options);
      this.addEventListener('focusout', () => { requestAnimationFrame(restart); }, options);
      document.addEventListener('visibilitychange', restart, options);
      this.mobile.addEventListener('change', () => { render(); restart(); }, options);
      this.pause?.addEventListener('click', () => { this.autoplay = !this.autoplay; render(); restart(); }, options);
      if (!this.cards.length) return;
      render();
      this.visibility = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; restart(); }, {threshold: .2});
      this.visibility.observe(this);
      restart();
    }
    disconnectedCallback() { this.events?.abort(); this.events = null; clearInterval(this.timer); this.visibility?.disconnect(); }
  });
}
